import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Holder = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 1.5rem;
  grid-row-gap: 1.5rem;
  button {
    width: 100%;
    margin: 0;
  }
  @media ( max-width: 767px ) {
    button:hover {
      color: ${props => props.theme.colours.link};
      background-color: ${props => props.theme.colours.white};
    }
  }
`;

class Buttons extends Component {

  state = {
    redirect: false,
    options: [],
  };

  clickHandler = ( e ) => {
    this.props.dispatch( {
      type: 'SET_ATTRIBUTE',
      avatarKey: this.props.avatarPrefix,
      valueKey: this.props.id,
      value: e.target.getAttribute( 'data-value' ),
    } );
    this.setState( {
      redirect: true,
    } );
  };

  render() {
    if ( this.state.redirect ) {
      return <Redirect push to={this.props.redirect}/>;
    } else {
      return (
        <Holder>
          {this.props.values.map(option => (
            <button className="small" key={option.value}  data-value={option.value} onClick={(e) => {this.clickHandler(e)}}>{option.text}</button>
          ))}
        </Holder>
      )
    }
  }
}

Buttons.propTypes = {
  avatarPrefix: PropTypes.string,
  redirect: PropTypes.string,
  id: PropTypes.string,
  values: PropTypes.array
};

export default connect(  )( Buttons );
